export default {
  data() {
    return {
      tableLenght: localStorage.getItem('dt.length') || 10,
      userData: null,
      sortColumn: '',
      sortByValue: 'asc',
      array: [],
      arrayFiltered: [],
      arrayList: {
        data: [],
        page: 0,
        per_page: 0,
        pre_page: 0,
        next_page: 0,
        total: 0,
        total_pages: 0
      },
      search: {
      }
    }
  },
  created: async function () {
    // let response = await this.$http.get("/user/me");
    // localStorage.setItem('user', JSON.stringify(response.data));
    // this.$user.data = response.data;
    if (!this.$user.data.role && this.userInfo) {
      this.$user.data = this.userInfo
    }
  },

  watch: {
    'sortColumn'(newValue, oldValue) {
      if (!newValue) return
      if (newValue !== oldValue) { this.sortByValue = 'asc' }
      this.sortTable()
    },
    'sortByValue'(n) {
      this.sortTable()
    },
    search: {
      deep: true,
      handler(value) {
        this.applySearch(value);
      }
    }
  },

  methods: {
    disableFor(arr) {
      if (!this.$user.data.role) return false
      return !arr.includes(this.$user.data.role[0])
    },
    enableFor(arr) {
      if (!this.$user.data.role) return false
      return arr.includes(this.$user.data.role[0])
    },
    sortTable() {
      let columnSorter = this.sortColumn

      let array = (this.arrayFiltered.length ? [...this.arrayFiltered] : [...this.array])
      if (this.arrayFiltered.length) {
        this.arrayFiltered = this._.orderBy(array, [columnSorter], [this.sortByValue])
      } else {
        this.array = this._.orderBy(array, [columnSorter], [this.sortByValue])
      }

      this.changePage(1)
    },
    sortBy() {
      this.sortByValue = (this.sortByValue === 'asc' ? 'desc' : 'asc')
    },
    applySearch(value) {
      let list = []
      let filter = {}
      for (let key in value) {
        if (value[key].length) {
          filter[key] = value[key]
        }
      }
      list = [...this.array.filter((account) => {
        for (let key in filter) {
          if (!account[key] || account[key] === undefined || !account[key].toLowerCase().trim().includes(filter[key].toLowerCase().trim())) {
            return false
          }
        }
        return true
      })]
      this.arrayFiltered = list
      this.arrayList = this.paginator(list, 1, this.tableLenght)
    },
    changePage(val) {
      let array = (this.arrayFiltered.length ? [...this.arrayFiltered] : [...this.array])
      this.arrayList = this.paginator(array, val, this.tableLenght)
    },
    getPageStart(pageSize, pageNr) {
      return pageSize * pageNr
    },

    getPageLabel(total, pageSize, pageNr) {
      const start = Math.max(
        this.getPageStart(pageSize, pageNr),
        0
      )
      const end = Math.min(
        this.getPageStart(pageSize, pageNr + 1),
        total
      )
      if (localStorage.getItem('lang') === 'ru')
        return `с ${start + 1} до ${end}`
      if (localStorage.getItem('lang') === 'ro')
        return `${start + 1} la ${end}`
    },

    paginator(items, current_page, per_page_items) {
      let page = current_page || 1,
        per_page = parseInt(per_page_items) || 10,
        offset = (page - 1) * per_page,

        paginatedItems = items.slice(offset).slice(0, parseInt(per_page_items)),
        total_pages = Math.ceil(items.length / per_page)

      return {
        page: page,
        per_page: per_page,
        pre_page: page - 1 ? page - 1 : null,
        next_page: (total_pages > page) ? page + 1 : null,
        total: items.length,
        total_pages: total_pages,
        data: paginatedItems
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixinTable.js